import { render, staticRenderFns } from "./DashboardTile.vue?vue&type=template&id=d5ad35a6&scoped=true"
import script from "./DashboardTile.vue?vue&type=script&lang=js"
export * from "./DashboardTile.vue?vue&type=script&lang=js"
import style0 from "./DashboardTile.vue?vue&type=style&index=0&id=d5ad35a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ad35a6",
  null
  
)

export default component.exports